module.exports = __webpack_public_path__ + "static/media/btn_print.5c542a97.svg";